module.exports = __webpack_public_path__ + "static/media/footer_img.2e4d06d7.svg";